import React from 'react'
import Layout from '../../components/common/pageLayout'
import Form from '../../components/WareHouse/add'
import constant from '../../constant'
import { toast } from 'react-toastify'
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min'
import { v3_edit_warehouse } from '../../actions/v3/wareHouseManagement'
const Add = (props) => {

    const location = useLocation();
    const { data, page } = location.state || {};
    const onSubmit = (model) => {
        model.previousName = JSON.parse(atob(data))['NAME']
        v3_edit_warehouse(model).then((res) => {
            if (res.status) {
                toast.success(res.result.message)
                props.history.push(constant.Authedcomponent.listWareHouse.url, {
                    page: page // Replace 'yourData' with the data you want to pass
                });
            }
            else {
                toast.error(res.error)
            }
        })
    }

    const onCancel = () => {
        props.history.push(constant.Authedcomponent.listWareHouse.url, {
            page: page // Replace 'yourData' with the data you want to pass
        });
    }
    return (
        <React.Fragment>
            <Layout
                title={'Edit Warehouse'}>
                <Form
                    title={'Edit Warehouse'}
                    onSubmit={onSubmit}
                    data={JSON.parse(atob(data))}
                    buttonName={'Save Warehouse'}
                    onCancel={onCancel}


                />
            </Layout>

        </React.Fragment>
    )
}

export default Add